import React from 'react';
import Icon from '@ant-design/icons';

const LayersIconSvg = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3334 8.99905C17.333 8.83001 17.2452 8.67318 17.1013 8.58444L15.4075 7.5403L17.1031 6.48493C17.2461 6.39593 17.3331 6.23952 17.3334 6.07113C17.3336 5.90271 17.2471 5.74603 17.1043 5.65661L9.25928 0.74126C9.10072 0.641911 8.89932 0.641911 8.74076 0.74126L0.895723 5.65661C0.753015 5.74603 0.66646 5.90271 0.666687 6.07113C0.666948 6.23955 0.753959 6.39597 0.89696 6.48493L2.58094 7.53304L0.896212 8.58607C0.753308 8.67539 0.666557 8.83206 0.66672 9.00058C0.666883 9.16911 0.753927 9.32562 0.896993 9.41468L2.58097 10.4628L0.896212 11.5157C0.753536 11.6049 0.666818 11.7613 0.66672 11.9295C0.666622 12.0978 0.753178 12.2543 0.895756 12.3436L8.74079 17.2589C8.82009 17.3086 8.91006 17.3334 9.00004 17.3334C9.09001 17.3334 9.18002 17.3086 9.25928 17.2589L17.1043 12.3436C17.2473 12.254 17.334 12.0968 17.3334 11.928C17.3327 11.7592 17.245 11.6027 17.1013 11.5142L15.4075 10.47L17.1031 9.41465C17.2466 9.32532 17.3337 9.1681 17.3334 8.99905ZM2.07684 6.06908L9.00004 1.7313L15.9232 6.06908C15.8567 6.11049 9.19844 10.2546 9.00004 10.3781L2.07684 6.06908ZM15.92 11.9332L9.00004 16.269L2.07547 11.9303L3.50415 11.0374L8.74203 14.2975C8.821 14.3466 8.91052 14.3712 9.00004 14.3712C9.08955 14.3712 9.17907 14.3466 9.25804 14.2975L14.4815 11.0464L15.92 11.9332ZM9.00004 13.3078L2.07765 8.99928L3.50415 8.10772L8.74203 11.3678C8.821 11.417 8.91052 11.4415 9.00004 11.4415C9.08955 11.4415 9.17907 11.417 9.25804 11.3678L14.4815 8.1167L15.9178 9.00211C15.8781 9.02682 9.1833 13.1937 9.00004 13.3078Z"
        fill="white"
      />
    </svg>
  );
};

export function LayersIcon(props: any) {
  return <Icon component={LayersIconSvg} {...props} />;
}
